import styled from "styled-components"

const YearFilter = styled.div`
  cursor: pointer;
  color: ${(props) =>
    props.active === true
      ? props.theme.b_color_gradients.b_dark
      : props.theme.a_color_gradients.a_dark};

  text-decoration: ${(props) =>
    props.active === true ? "dashed underline" : "none"};
`

const MonthFilter = styled.button`
  color: ${(props) =>
    props.active === true ? "black" : props.theme.a_color_gradients.a_dark};

  text-decoration: ${(props) =>
    props.active === true ? "dashed underline" : "none"};
`

export { YearFilter, MonthFilter }
